import { BASIC_ACTION_LABELS } from './basic-action-labels.js';
import { SCREEN_NAMES } from './screen-names.js';
import { SCREENS } from './screens.js';
const SCREEN_ACTION_LABELS = new Map(SCREENS.flatMap((screen) => Object.entries(screen.actions ?? {}).map(([action, label]) => [`${screen.module}:${action}`, label])));
function humanize(camelCase) {
    const words = camelCase.replace(/([a-z0-9])([A-Z])/g, '$1 $2').toLowerCase();
    return words.charAt(0).toUpperCase() + words.slice(1);
}
/** A permission key as people read it: `salesOrder:view` → "Sales Orders · View". */
export function permissionLabel(permission) {
    const [moduleKey = '', action = ''] = permission.split(':');
    const screen = SCREEN_NAMES[moduleKey] ?? humanize(moduleKey);
    const actionLabel = SCREEN_ACTION_LABELS.get(permission) ??
        BASIC_ACTION_LABELS[action] ??
        humanize(action);
    return `${screen} · ${actionLabel}`;
}
//# sourceMappingURL=permission-label.js.map